import { CalculatedUploadState } from '../useCalculatedUploadState';
import { GcpPlacementService, ScheduledFlight, Site } from '../../../../../../types';
import { determineIfScopeIsPanoOnly, determineIfScopeIsScan, guessScanUploadType } from '../../../helpers/scope';
import { declense } from '../../../../../../libs/declense';
import { uploadTypeToHuman } from '../../../helpers/uploadType';
import { UploadValidationStatus } from '../../../../../../consts/uploadValidationStatus';

export type BadgeData = {
  label: string;
  uploadState: CalculatedUploadState | null;
  validationStatus: UploadValidationStatus;
  isOverdue: boolean;
};

export interface Params {
  scanState: CalculatedUploadState | null;
  panoState: CalculatedUploadState | null;
  gcpState: CalculatedUploadState | null;
  isScanOverdue: boolean;
  isPanoOverdue: boolean;
  isGcpOverdue: boolean;
  scanValidationStatus: UploadValidationStatus;
  panoValidationStatus: UploadValidationStatus;
  site: Site;
  schedule?: ScheduledFlight;
  gcpPlacementService?: GcpPlacementService;
}

export const determineBadges = ({
  scanState,
  panoState,
  gcpState,
  isScanOverdue,
  isPanoOverdue,
  isGcpOverdue,
  scanValidationStatus,
  panoValidationStatus,
  site,
  schedule,
  gcpPlacementService,
}: Params) => {
  if (!schedule && !gcpPlacementService) {
    return [];
  }

  const badges: BadgeData[] = [];

  if (schedule) {
    if (determineIfScopeIsScan(schedule.scope)) {
      badges.push({
        label: uploadTypeToHuman(guessScanUploadType(schedule.scope, schedule.imageryGeolocationalAccuracy, undefined)),
        uploadState: scanState,
        isOverdue: isScanOverdue,
        validationStatus: scanValidationStatus,
      });
    } else if (schedule.scope && !determineIfScopeIsPanoOnly(schedule.scope)) {
      badges.push({
        label: schedule.scope,
        uploadState: scanState,
        isOverdue: false,
        validationStatus: UploadValidationStatus.Success,
      });
    }

    const panoramasPerScan = site.projectInfo.parsedPanoramaLocations?.length ?? 0;
    if (panoramasPerScan) {
      badges.push({
        label: declense(panoramasPerScan, 'Panorama', 'Panoramas'),
        uploadState: panoState,
        isOverdue: isPanoOverdue,
        validationStatus: panoValidationStatus,
      });
    }
  }

  if (gcpPlacementService) {
    badges.push({
      label: 'GCPs',
      uploadState: gcpState,
      isOverdue: isGcpOverdue,
      validationStatus: UploadValidationStatus.Success,
    });
  }

  if (schedule?.contractContainsRfmm) {
    badges.push({
      label: 'rFMM',
      uploadState: gcpState,
      isOverdue: false,
      validationStatus: UploadValidationStatus.Success,
    });
  }

  return badges;
};
